module.exports = __webpack_public_path__ + "static/media/ic_etiqueta.66421ea1.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_etiqueta.webp
// module id = 197
// module chunks = 1